import type { ActivityType } from "../shared/types";

export const TYPE_META: Record<ActivityType, { icon: string; label: string; description: string }> = {
  "guess-number": { icon: "🔢", label: "Guess the Number", description: "Players use higher and lower clues to find their hidden number" },
  "word-scramble": { icon: "🔀", label: "Word Scramble", description: "Unscramble one or more words or phrases" },
  "word-search": { icon: "🔎", label: "Word Search", description: "Swipe across every hidden word" },
  puzzle: { icon: "🧩", label: "Puzzle", description: "Solve a mobile-friendly 3 × 3 image puzzle" },
  response: { icon: "💬", label: "Response", description: "Share free-text responses to up to three live questions" },
};
